import React from 'react';
import {connect} from "react-redux";
import {Button, Typography} from "antd";

import {AuthActions} from "@redux";
import {i18, trb, getFormattedLanguageFromStorage} from "@utilities";
import {history, routerPath} from "@config";

class IndexContainer extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            currentStep: 0
        }
    }
    
    nextStep = () => {
        this.setState({
            currentStep: 1
        })
    }
    
    getIdentificationUrl = async () => {
        const {dispatch} = this.props;
        const windowReference = window.open();
        const language = getFormattedLanguageFromStorage();
        try {
            const response = await dispatch(AuthActions.getIdentificationUrl(language));
            windowReference.location = response.payload.redirectUrl;
        } catch (e) {
        }
    }
    
    render() {
        return <>
            {this.state.currentStep === 0 && <>
                <div className="col-12 col-md-6 px-3 order-2 order-md-1">
                    <Typography.Title level={1} className="mb-5">
                        {trb(i18.MessageTitles.PreSign)}
                    </Typography.Title>
                    <Typography.Title level={5} className="mb-5">
                        {trb(i18.Messages.PreSignFirst)}
                        <br/><br/>
                        {trb(i18.Messages.PreSignSeconds)}
                    </Typography.Title>
                    <div className="mt-md-3">
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            onClick={this.nextStep}
                        >
                            {trb(i18.Buttons.PreSignIn)}
                        </Button>
                    </div>
                </div>
                <div className="col-12 col-md-6 row order-1 order-md-2">
                    <img src="/images/slider/onboarding_first.webp" className="w-100" alt="start onboarding icon"/>
                </div>
            </>}
            {this.state.currentStep === 1 && <>
                <div className="col-12 col-md-6 px-3 order-2 order-md-1">
                    <Typography.Title level={1}>
                        {trb(i18.Messages.HowOpenCompanyAccount)}
                    </Typography.Title>
                    <Typography.Paragraph>
                        {trb(i18.Messages.FirstNeedVerifyYourIdentity)}
                    </Typography.Paragraph>
                    <Button
                        size="large"
                        type="primary"
                        className="mb-3"
                        onClick={this.getIdentificationUrl}
                    >
                        {trb(i18.Buttons.IdentificationRedirect)}
                    </Button>
                    <Typography.Paragraph>
                        {trb(i18.Messages.SecondLoginProvideDocuments)}
                    </Typography.Paragraph>
                    <Button
                        className="mb-3"
                        size="large"
                        onClick={() => history.push(routerPath.login)}
                    >
                        {trb(i18.Buttons.ToSignIn)}
                    </Button>
                    <Typography.Paragraph>
                        {trb(i18.Messages.SignSecond)}
                        <div className="my-3">
                            - {trb(i18.Messages.SignTable1)}
                            <br/> - {trb(i18.Messages.SignTable2)}
                            <br/> - {trb(i18.Messages.SignTable3)}
                            <br/> - {trb(i18.Messages.SignTable4)}
                        </div>
                        <div className="mb-3">
                            {trb(i18.Messages.SignThird)}
                        </div>
                        <div>
                            {trb(i18.Messages.SignFirst)}
                        </div>
                    </Typography.Paragraph>
                </div>
                <div className="col-12 col-md-6 row order-1 order-md-2">
                    <img src="/images/slider/onboarding_second.webp" className="w-100" alt="start onboarding icon"/>
                </div>
            </>}
        </>;
    }
};

function mapStateToProps(state) {
    const {sendAuth, sendStartLogin, startLogin, checkSca, identificationUrl} = state.AuthReducers;
    const {send} = state.translationReducer;
    
    return {
        sendAuth, sendStartLogin, startLogin, checkSca, identificationUrl,
        send
    };
}

const connectedIndexContainer = connect(mapStateToProps)(IndexContainer);
export {connectedIndexContainer as IndexContainer};
